import { communicationPreferencesAtom, communicationPreferencesViewAtom } from "@/atoms/communication-preferences"
import { orderUpdatesChoice, persistOrderUpdatesChoice } from "@/domain/communication-preferences/api"
import { useAtom, useAtomValue, useSetAtom } from "jotai"
import { checkoutAtom } from "../state"

/** The review step's order-update WhatsApp box and how it changes and is kept. */
export type OrderUpdatesChoice = {
  notifyStatusWhatsapp: boolean
  change: (checked: boolean) => void
  persist: () => void
}

/**
 * The order-update box: picked on this order (checkout state), else the customer's saved choice, else on. `persist`
 * runs once the order is placed and saves in the background when the choice changed; a failure never reaches the order.
 */
export function useOrderUpdatesChoice(): OrderUpdatesChoice {
  const [state, setState] = useAtom(checkoutAtom)
  const stored = useAtomValue(communicationPreferencesViewAtom)
  const refreshStored = useSetAtom(communicationPreferencesAtom)
  const notifyStatusWhatsapp = orderUpdatesChoice(state.notifyStatusWhatsapp, stored)

  function change(checked: boolean) {
    setState((prev) => ({ ...prev, notifyStatusWhatsapp: checked }))
  }

  function persist() {
    void persistOrderUpdatesChoice(stored, notifyStatusWhatsapp).then((saved) => {
      if (saved) refreshStored()
    })
  }

  return { notifyStatusWhatsapp, change, persist }
}
